<template>
    <div class="mainLayout">
        <div class="lookup lookupDiv inner">
            <p class="innerTitle">{{lookupPromptText}}</p>
            
            <div class="horizFlex">
                <input ref="lookupText" id="lookupText"  class='lookupText' v-model="lookupTextValue" @keyup.enter='lookup'/>
                <button class="lookupGo" v-on:click="lookup">{{lookupButtonText}}</button>
            </div>
            <div class="inactiveCheck">
                <input type="checkbox" id="jake" v-model="showInactiveClubs">
                <label for="jake" class="rosterName" >{{showInactiveText}}</label>
            </div>
            <div class="wait" v-show="pleaseWait">
                <label for="">Please Wait...</label>
            </div>
            <div class="lookupResults" >
                <button class="resultButton" v-for="result in lookupResults" :key="result.id" v-on:click="getClub(result.id)">
           
                        {{result.name}} 
                      
               
                    
                </button>  
            </div>
        </div>
        <div v-if="isSelectedResult">
            <div class="main inner personCard" >
                
                <div class="personAddress">
                    <div class="horizFlex">
                        <p class="personName">{{selectedResult.name}}</p> 
                        
                    </div>
                    <div class="horizFlex">
                        <p class="inactiveclub" v-if="selectedResult.isActive==false">INACTIVE</p>
                    </div>
                    <!-- view fields -->
                    <div class="horizFlex" v-if="!inEdit">
                        
                        <ul class="textlist" >
                            
                            <li class="locationtitle">{{locationText}}</li>
                            
                            <li>{{selectedResult.address1}}</li>
                            <li v-if="selectedResult.city!=null">{{selectedResult.city + ', ' + selectedResult.state + ' ' + selectedResult.zip}}</li>
                            <hr/>
                            <li>{{selectedResult.phone | formatPhone}}</li>
                            <button class="linkButton linkButtonMedium" >{{ selectedResult.email }}</button>
                        </ul>
                    </div>

                    <!-- edit fields -->
                    <div class="vertFlex" v-if="inEdit">
                        <div class="horizFlex">
                            <label class="locationtitle">{{locationText}}</label>
                        </div>
                         <div class="horizFlex">
                            <label for="" class="editLabel">Name</label>
                            <input class="editField" v-model="selectedResult.name"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Address Line 1</label>
                            <input class="editField" v-model="selectedResult.address1"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">City</label>
                            <input  class="editField" v-model="selectedResult.city"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">State</label>
                            <select name="" id="" class='editCombo' v-model="selectedResult.stateId">
                                <option v-for="state in states" :key="state.id" :value="state.ID">
                                    {{state.Name}}
                                </option>
                            </select>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Zip</label>
                            <input  class="editField" v-model="selectedResult.zip"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Phone</label>
                            <input  class="editField" v-model="selectedResult.phone"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Email</label>
                            <input class="editField"  v-model="selectedResult.email"/>
                        </div>
                        <div class="horizFlex">
                            <input type="checkbox" id="jake" v-model="selectedResult.isActive">
                            <label for="jake" class="editLabel" >Is Active</label>
                        </div>
                        
                        
                        
                        
                    </div>
                </div>
                
                <div class="personAction" v-if="!inEdit">
                    <button class="buttonPerson" v-on:click="editClub()" :disabled="disableEdit">{{editButtonText}}</button>
                </div>
                <div class="personAction" v-if="inEdit">
                    <button class="buttonPerson" v-on:click="saveClub()">{{saveButtonText}}</button>
                    <button class="buttonPerson" v-on:click="cancelEditClub()">{{cancelButtonText}}</button>
                    <label for="" class="error">{{errorMessage}}</label>
                </div>
            </div>
            <div class="detail innerTransparent">
                
                <div class="itemTitleBar">
                    <div class="horizFlex itemTitle">
                        <p class="itemBarTitle itemTitle">{{personTitleText}}</p>
                        <!-- <p class="itemBarSubTitle">{{lastAttendedText}} {{selectedResult.lastAttendedDate}}</p> -->
                        <p class="itemBarSubTitle">{{personCountText}} {{selectedResult.peopleCount}}</p>
                    </div>
                    <div class="inactiveCheck">
                        <input type="checkbox" id="jake" v-model="showInactivePeople">
                        <label for="jake" class="rosterName" >{{showInactiveText}}</label>
                    </div>
                    <!-- <button class="addButton" disabled=true>{{addPersonButtonText}}</button> -->
                    
                </div>
                <div class="scrollDiv">
                    <div  v-for="person in filteredPeople" :key="person.clubMembershipId">
                        <clubmembership :person="person" :roles="roles" v-on:showinactive="showInactive" v-on:canceledit="cancelEditPerson" :canEdit="canEdit"/>
                        
                    </div>   
                   
                </div>
            </div>
        </div>
    </div>

  
</template>

<script>
import {HTTP} from '../Repository'
import clubmembership from './ClubMembership.vue'
import tokenhelper from '../tokenhelper.js'
export default {
    mixins:[tokenhelper],
    props:{
        canEdit:{
            type:String,
            default:'false'
        },
        personId:{
            type:Number,

        }
    },
    components:{
        clubmembership
    },
    data(){
        return{
            pleaseWait:false,
            inEdit:false,
            errorMessage:'',

            showInactiveClubs:false,
            lookupTextValue:'',
            lookupResults:{},
            roles:{},
            clubs:{},
            states:{},
            selectedResult:{},
            isSelectedResult:false,

            showInactivePeople:false,

            lookupPromptText:'Lookup Club',
            lookupButtonText:'Go',
            editButtonText:'Edit',
            firstAttendedText:'First Attended',
            lastAttendedText:'Last Meeting:',
            startedRoleText:'Started Role:',
            enrolledDateText:'Enrolled:',
            addPersonButtonText:'Add Person',
            showInactiveText:'Show Inactive',
            personCountText:'Active Members:',
            personTitleText:'Members',
            saveButtonText:'Save',
            cancelButtonText:'Cancel',
            editDuesPaidText:'Dues Paid',
            isActiveText:'Is Active',
            locationText:'Meeting Location'
        }
    },
    mounted(){
        this.getRoles();
        this.getStates();
    },
    computed:{
        disableEdit:function(){
            return this.canEdit=='false' || this.canEdit=='False'
        },
    	assocDuesText:function(){
            if(this.selectedResult.associationDuesPaid){
                return "$ Association Dues Paid";
            }else{
                return "$ Association Dues UNPAID";
            }
        },
        assocDuesClass:function(){
            if(this.selectedResult.associationDuesPaid){
                return "paidmain";
            }else{
                return "unpaidmain";
            }
        },
        filteredPeople(){
            if(this.showInactivePeople){
                return this.selectedResult.people
            }else{
                let tempPeople = this.selectedResult.people
                if(tempPeople!=undefined){
                    tempPeople = tempPeople.filter((item)=>{
                        return (item.isActive)
                    })
                }
                
                return tempPeople
            } 
        },
        rolesWithoutAll(){
            let tempRoles = this.roles;
            tempRoles.splice(0,1);
           
            return tempRoles;
        },
    },
    filters: {
        formatPhone(phn) {
            if(phn!=null){
                return "(" + phn.substring(0,3) + ") " + phn.substring(3,6) + "-" + phn.substring(6);       
            }
            
            
        }
    },
    methods:{
        AddTokenToAPI(){
            var token = this.getToken()   
            HTTP.defaults.headers.post['token']=token
        },
       /*  updateIsActive(isActive){
            console.log("updateIsActive " + isActive)
            if(isActive==false){
                this.showInactivePeople=true;
            }
        }, */
        showInactive(){
            this.showInactivePeople=true;
        },
        
        lookup(){
            let req = {
                lookupText:this.lookupTextValue,
                includeInactive:this.showInactiveClubs,
                personId:this.personId
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('lookupclubadmin',req)
            .then(response=>{
                this.lookupResults = response.data.ClubList
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
            
        },
        
        getClub(clubID){
            

            let req = {
                clubId:clubID
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('club',req)
            .then(response=>{
                this.selectedResult = response.data.club
                this.isSelectedResult=true;
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
            
        },

        editClub(){
            this.inEdit=true
        },
        
        cancelEditClub(){
            this.inEdit=false
            
        },
        saveClub(){
            let req = {
                club:this.selectedResult
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('saveclub',req)
            .then(response=>{

                if(response.data.success){
                    
                    this.inEdit=false
                }else{
                    this.errorMessage="API Error: " + response.data.RequestException.Message;
                }
                this.pleaseWait=false;
                this.getClub(this.selectedResult.id)
            })
            .catch(e=>{
                this.pleaseWait=false;
                console.log('saveclub fail')
                return e
            });
        },   
        cancelEditPerson(){
            this.getClub(this.selectedResult.id)
        },
        /* getpersonByID(clubMembershipId){
            var i;
            for(i=0;i<this.selectedResult.people.length;i++){
                var person = this.selectedResult.people[i]
                if(person.clubMembershipId==clubMembershipId){return person}
            }
        },
        toggleperson(clubMembershipId){
            
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                if(person.tag==""){
                    person.tag="Detail"
                }else if(person.tag=="Detail"){
                    person.tag=""
                }
            }
            
        },
        personShowDetail(clubMembershipId){
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                return person.tag=="Detail" || person.tag=="Edit"
            }
        },
        personInEdit(clubMembershipId){
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                return person.tag=="Edit"
            }
        },
        editperson(clubMembershipId){
            console.log("inedit" + clubMembershipId)
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                person.tag="Edit"
            }
        },
        saveperson(clubMembershipId){
            console.log("insave")
            //API save
            this.savePerson
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                let req = {
                    clubmembership:person
                }
                HTTP.post('savemembership',req)
                .then(response=>{
                    console.log(response)
                    if(person!=undefined){
                        person.tag=""
                        person.clubMembershipId=response.data.ResponseInteger
                    }
                    
                })
                .catch(e=>{
                    console.log(e)
                });

                
            }
        },
      
        cancelEditperson(clubMembershipId){
            console.log("incancel")
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                person.tag=""
                if(person.clubMembershipId==-1){
                    this.selectedResult.people.splice(0,1);
                }
                //put the data back
                this.getClub(this.selectedResult.id)
            }
        }, */
        /* personClass(clubMembershipId){
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                if(!person.isActive){
                    return "inner innerInactive itemDetail"
                }else if(person.tag=="Detail"){
                    return "inner itemDetailOpen";
                }else{
                    return "inner itemDetail";
                }
            }
        },
        personDuesClass(clubMembershipId){
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                if(person.duesPaid){
                    return "paid";
                }else{
                    return "unpaid";
                }
            }
        }, */
       /*  personDuesText(clubMembershipId){
            var person = this.getpersonByID(clubMembershipId)
            if(person!=undefined){
                if(person.duesPaid){
                    return "Dues $: Paid";
                }else{
                    return "Dues $: UNPAID";
                }
            }
        },
        personNameText(clubMembershipId){
            var person = this.getpersonByID(clubMembershipId)
            console.log(person)
            if(person!=undefined){
                person.roleName = this.getRoleName(person.roleId)
                if(person.roleName!=""){
                    return person.personName + " (" + person.roleName + ")";
                }else{
                    return person.personName;
                }
            }
        }, */
        getRoleName(roleId){
            var i;
            for(i=0;i<this.roles.length;i++){
                var role = this.roles[i]
                if(role.id==roleId){return role.name}
            }
        },
        getRoles(){
            let req = {
                memberID:"1"
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('roles',req)
            .then(response=>{
                this.roles = response.data.roles
                
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
        },
        getStates(){
            let req = {
                memberID:"1"
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('states',req)
            .then(response=>{
              
                this.states = response.data.ValueList
               
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
        },
    }
}
</script>

<style scoped>
.wait{
    font-size:x-large;
    color:rgb(238,120,45);
    padding:20px;
}
.error{
    font-size:large;
    color:red;
    padding:20px;
}
/* main */
.mainLayout{
    display:grid;
    grid-template-columns:1fr 4fr;
    grid-template-rows:1fr 3fr;
    grid-template-areas: 
    "lookup main"
    "lookup detail";
}
/*areas*/
.lookup{
    grid-area:lookup;
}
.main{
    grid-area:main;   
}
.detail{
    grid-area:detail; 
}
.scrollDiv{
    height:370px;
    overflow-x:hidden;
    overflow-y:scroll;
}
.inner{
    border-radius:10px; 
    margin:10px;
    padding:0px;
    text-align: left;
    background-color: white;
}
.innerInactive{
    background-color: lightgray;
}
.innerTitle{
    font-size:x-large;
    color:rgb(0,158,192);
}
.horizFlex{
  display:flex;
  flex-direction: row;
  margin:5px;
}
.linkButton{
  background-color: transparent;
  color: rgb(0,158,192);
  font-size:small;
  border:none;
  padding:0px;
}
.linkButtonMedium{
  font-size:medium;
  
}
/*lookup*/
.lookupDiv{
    grid-area:lookup;
    height:650px;
    padding-left:10px;
    padding-right:10px;
}

.lookupText{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:160px;
}

.lookupGo{
    background-color: rgb(238,120,45);
    border:none;
    border-radius:5px;
    margin-left:3px;
    color:white;
}
.lookupSelect{
  outline-color:rgb(238,120,45);
  outline-width:2px;
  border-radius: 5px;
  font-size:inherit;
  width:200px;
  margin-bottom:5px;
}

.lookupResults{
    padding:0px;
    margin-top:10px;
    height:480px;
    overflow-x:hidden;
    overflow-y:scroll;
}
.resultButton{
    width:96%;
    margin:5px;
    background-color:rgb(196, 218, 226);
    border:none;
    border-radius:10px;
    padding:10px;
    color:rgb(0,158,192);
    font-size:medium;
}
.resultButton:focus{
    /* color:rgb(238,120,45); */
    font-weight:bold;
    outline-style:none;
    border-color:rgb(238,120,45);
    border-width:2px;
    border-style:solid;
}
/* personcard */
.personCard{
    display:grid;
    grid-template-columns:400px auto 120px;
    grid-template-rows:auto;
    grid-template-areas: 
    "address space personaction";
}
.personPhoto{
    grid-area:photo;
}
.image{
    margin:20px;
}
.personAddress{
    grid-area:address;
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    margin-left:10px;
}
.personAction{
    grid-area:personaction;
    display:flex;
    flex-direction: column;
    text-align: center;
}
.locationtitle{
    color:rgb(0,158,192);
}
.personName{
    font-size:xx-large;
    font-weight:bold;
    color:rgb(0,158,192);
    margin-bottom:5px;
    margin-top:10px;
}
.textlistdiv{
    text-align:left;
}
.textlist{
    list-style-type:none;
    padding-left:0;
    margin-right:60px;
}
.paidmain{
    color:green;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.unpaidmain{
    color:red;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.paid{
    color:green;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.unpaid{
    color:red;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.inactive{
    color:rgb(53, 48, 48);
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.isactive{
    font-size:large;
    margin-top:10px;
    margin-left:30px;
}
/* club item */
.itemDetailOpen{
    display:grid;
    grid-template-columns:300px auto 10px 120px;
    grid-template-rows:1fr 1fr;
    grid-template-areas: 
    "clubtitle space paid action"
    "clubdate space paid action";
    height:140px;
}
.itemDetail{
    display:grid;
    grid-template-columns:300px auto 10px 120px;
    grid-template-rows:1fr;
    grid-template-areas: 
    "clubtitle space paid action";
}
.itemSpace{
    grid-area:space;
    text-align:center;
    display: flex;
    flex-direction: column-reverse;
}
.clubTitle{
    grid-area:clubtitle;
    margin-left:10px;
}
.clubDate{
    margin-left:10px;
}
.titleGrid{
    display:grid;
    grid-template-columns:200px auto 100px 100px;
    grid-template-rows:1fr 1fr 1fr;
    grid-template-areas: 
    "maintitle space paid action"
    "address1 phone paid action"
    "address2 email paid action";
}
.itemAction{
    grid-area:action;
    display:flex;
    flex-direction: column;
    text-align: center;
}

/* itemtitle */
.itemTitleBar{
    display:grid;
    grid-template-columns:300px  auto 140px 120px;
    grid-template-rows:auto;
    grid-template-areas: 
    "title  space inactive add";
    margin-left:10px;
    margin-right:10px;
  
}
.itemTitle{
    grid-area:title;
    
}
.itemBarTitle{
    font-size:x-large;
    /* color:rgb(0,158,192); */
    color:rgb(0,158,192);
    font-weight: bold;
}
.itemBarSubTitle{
    font-size:large;
    color:rgb(0,158,192);
    /* color:rgb(0,158,192); */
    margin-top:30px;
    margin-left:30px;
}
.inactiveCheck{
    grid-area:inactive;
    margin-top:30px;
    color:rgb(0,158,192);
}
.addButton{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 120px;
   height:40px;
   margin-top:20px;
   margin-right:20px;
}


.button{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 0px 20px;
   width: 85px;
}
button:disabled{
    background-color:lightgray;
}
.buttonPerson{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 5px 20px;
   width: 85px;
}


.innerTransparent{

    padding:0px;
    text-align: left;

}

.editLabel{
    width:120px;
    margin:5px;
}
.editField{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:160px;
    margin:5px;
}
.editCombo{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:170px;
    margin:5px;
}

.inactiveclub{
    color:red;

}

</style>

